import React from 'react'
import MyProfile from 'src/containers/Employees/MyProfile'

const profileFields = [
	{ value: 'name', label: 'Name' },
	{ value: 'email', label: 'Email' },
	{ value: 'phone', label: 'Phone' },
	{ value: 'gender', label: 'Gender' },
	{ value: 'birthday', label: 'Birthday' },
	{ value: 'role', label: 'Account type' },
	{ value: 'employee_roles', label: 'Permissions', width: 100 },
	{ value: 'status', label: 'Status' },
	{ value: 'created_at', label: 'Created at' },
	{ value: 'updated_at', label: 'Updated at' },
	{ value: 'last_login_at', label: 'Last login at' },
]

function MyProfilePage() {
	return (
		<MyProfile
			fields={profileFields}
			label="My Profile"
			goBack="/"
		/>
	)
}

export default React.memo(MyProfilePage)
